<template>
  <div class="p-question-checkbox" :class="{'p-question-checkbox--vertical':isVertical}">
    <div v-for="(checkbox, index) in answer.body.answers" :key="index" class="checkboxRadioButtonDisplay">
      <input type="checkbox" class="checkboxInput" :id="`checkbox_${answer.id}_${index}${fromSelect}`"
             :value="checkbox.answerText"
             tabindex="-1"
             :name="`checkbox_${answer.id}`"
             @change="getValue(checkbox.answerText)"
             @input="getLabelValue(answer.display_options.choicesLabel === 1 ? checkbox.answerText : getChoicesLabel[answer.display_options.choicesLabel][index])"
      >
      <label class="p-question-checkbox__inner" :tabindex="tabIndex" @keyup.enter="enterKeyPress(answer, checkbox.answerText, index)" :for="'checkbox_'+answer.id+'_'+index + fromSelect">
        <div class="label">
          <div class="label__text" :id="`checkbox_${answer.id}_${answer.sort_order}_${index}`">
            <markdown-view :rawText="answer.display_options.choicesLabel === 1 ? checkbox.answerText : getChoicesLabel[answer.display_options.choicesLabel][index]" :souruby="isSouruby"></markdown-view>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted} from "vue"
  import {CHOICESLABEL} from "@/consts/choicesLabel";

  const labelName = ref([])
  const getChoicesLabel = CHOICESLABEL

  const props = withDefaults(
    defineProps<{
      modelValue: Array<any>;
      answer: any;
      fromSelect?: string;
      tabIndex?: number;
      prevAnswerText?: string;
      isSouruby?: boolean;
      isVertical?: boolean;
    }>(),
    {
      isSouruby: false,
      isVertical: false,
      prevAnswerText: "",
      tabIndex: 0,
      fromSelect: "",
    }
  );
  
  const emit = defineEmits<{
    (e: 'input', id: Array<any>): void,
    (e: 'select-label', id: Array<any>): void,
  }>()

  onMounted(() => {
    // restore answer selection for skip question
    // make a array of original text string to separate all selected answer
    let answerTextList = props.prevAnswerText.split(" ／ ")
    // for answer display option is original text
    if(props.answer.display_options.choicesLabel === 1){
      for(let index in props.answer.body.answers){
        // if restore answers are match in original answers then mark that button as checked
        if(answerTextList.includes(props.answer.body.answers[index].answerText)){
          const checkBox: any = document.getElementById(`checkbox_${props.answer.id}_${index}${props.fromSelect}`)
          checkBox.checked = true
          labelName.value.push(props.answer.body.answers[index].answerText)
        }
      }
      // emit the restore answers list to store in vuex
      emit('input', answerTextList)
    }
    // for answer display option is not original text like "ア","イ","ウ"... | "Ⓐ","Ⓑ","Ⓒ"... | "1","2","3",...
    else{
      for(let index in props.answer.body.answers){
        // find the restore answers in original answer list and mark it selected
        if(answerTextList.includes(CHOICESLABEL[props.answer.display_options.choicesLabel][index])) {
          const checkBox: any = document.getElementById(`checkbox_${props.answer.id}_${index}${props.fromSelect}`)
          checkBox.checked = true
          labelName.value.push(CHOICESLABEL[props.answer.display_options.choicesLabel][index])
        }
      }
      // make a original answer list
      let originalAnswerText = props.answer.body.answers.map(i => i.answerText)
      // find original restore answer text from choices label
      answerTextList = answerTextList.map(item => originalAnswerText[CHOICESLABEL[props.answer.display_options.choicesLabel].indexOf(item)])
      emit('input', answerTextList)
    }
    emit('select-label', labelName.value)
  })

  function getValue(checkedValue){
    emit('input', props.modelValue.includes(checkedValue) ? props.modelValue.filter(v=>v!==checkedValue) : [...props.modelValue,checkedValue].filter(v=>v))
  }

  function getLabelValue(checkedName){
    if (labelName.value.includes(checkedName)) {
     labelName.value = labelName.value.filter(v=>v!==checkedName)
    }else{
      labelName.value.push(checkedName)
    }
    emit('select-label', labelName.value)
  }
  function enterKeyPress(answer, text, index) {
    const checkBox: any = document.getElementById(`checkbox_${answer.id}_${index}${props.fromSelect}`)
    checkBox.checked = !checkBox.checked;
    getValue(text)
    getLabelValue(answer.display_options.choicesLabel === 1 ? text : CHOICESLABEL[answer.display_options.choicesLabel][index])
  }

</script>
